import { atom } from "jotai";

export interface ITrackableItemZoneAllowlist {
    id?: number;
    trackable_item_id: string;
    zone_id: number;
}

export interface ITrackableItemZoneAllowlistInput extends Omit<ITrackableItemZoneAllowlist, 'id'> {}

export const allowlistAtom = atom<ITrackableItemZoneAllowlist[]>([]);
export const allowlistLoadingAtom = atom<boolean>(false);

